import * as React from "react";

import { Space } from "antd";
import { useAppState } from "../state";
import { useTranslation } from "@opendash/i18n";
import { Link } from "@opendash/router";

interface Props {}

export const FooterComponent = React.memo<Props>(function FooterComponent({}) {
  const t = useTranslation();
  const state = useAppState();

  return (
    <>
      <Space direction="vertical" size={8}>
        <Space direction="horizontal">
          {state.tenantConfig?.get("imprintUrl") ? (
            <a
              href={state.tenantConfig?.get("imprintUrl")}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("app:footer.imprint")}
            </a>
          ) : state.tenantConfig?.get("imprintText") ? (
            <Link to="/impressum" children={t("app:footer.imprint")} />
          ) : null}

          {state.tenantConfig?.get("tosUrl") ? (
            <a
              href={state.tenantConfig?.get("tosUrl")}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("app:footer.tos")}
            </a>
          ) : state.tenantConfig?.get("tosText") ? (
            <Link to="/agb" children={t("app:footer.tos")} />
          ) : null}

          {state.tenantConfig?.get("privacyUrl") ? (
            <a
              href={state.tenantConfig?.get("privacyUrl")}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("app:footer.privacy")}
            </a>
          ) : state.tenantConfig?.get("privacyText") ? (
            <Link to="/datenschutz" children={t("app:footer.privacy")} />
          ) : null}

          <span style={{ margin: "0 4px" }}>|</span>

          <Link to="/verwendungshinweis">Verwendungshinweis</Link>
        </Space>
      </Space>
    </>
  );
});
